import React, { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import Box from "@mui/material/Box";

import List from "./List";
import Tile from "./Tile";

import Mapping from "../../MappingView";
import ComponentSuspense from "../../../../Common/ComponentSuspense";
import { navEntities } from "../../../../kmk/AppData";
import { ENTITY_VIEWS } from "../data";

const ERDiagram = React.lazy(() => import("./ERDiagram"));

const useStyles = makeStyles()((theme) => ({
  PanelContainer: {
    marginTop: "25px",
    padding: "0px 25px",
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    minWidth: "100%",
    width: "100%",
    minHeight: "250px",
    marginLeft: "inherit",
  },
}));

function Entities({
  view,
  loading,
  entities,
  diagramEntities,
  mappedObjects,
  selectedTags,
  dataLoaded,
  handleDeleteClick,
}) {
  const { Workspace_id } = useParams();
  const { classes } = useStyles();
  const navigate = useNavigate();

  const handleEditClick = useCallback(
    (id) => {
      navigate(`/my-workspaces/${Workspace_id}/entities/${id}`);
    },
    [Workspace_id, navigate]
  );

  const navigateToDashboard = useCallback(
    (state) => {
      navigate(`/my-workspaces/${Workspace_id}/${navEntities.link}/statistics`, {
        state,
      });
    },
    [Workspace_id, navigate]
  );

  switch (view) {
    case 1:
      return (
        <Box className={classes.PanelContainer}>
          <List
            loading={loading}
            entities={entities}
            selectedTags={selectedTags || []}
            dataLoaded={dataLoaded || false}
            handleEditClick={handleEditClick}
            navigateToDashboard={navigateToDashboard}
            handleDeleteClick={handleDeleteClick}
          />
        </Box>
      );
    case 2:
      return (
        <Box className={classes.PanelContainer} sx={{ overflowY: "auto" }}>
          <Tile loading={loading} entities={entities} navigateToDashboard={navigateToDashboard} />
        </Box>
      );
    case 3:
      return !loading && diagramEntities.length ? (
        <ComponentSuspense>
          <ERDiagram entities={diagramEntities} />
        </ComponentSuspense>
      ) : (
        <></>
      );
    case ENTITY_VIEWS.Mapping:
      return !loading && mappedObjects !== false ? <Mapping mappedObjects={mappedObjects} /> : <></>;
    default:
      return <List loading={loading} />;
  }
}

export default Entities;
